// Style
require('../../css/bootstrap.css');

require('../../css/components.css');
require('../../css/frame.css');
require('../../css/frame_selectie.css');
require('../../css/vars.css');
require('../../css/icons.css');

require('../../css/custom/loading-bar.css');
require('../../css/custom/custom.css');
require('../../css/custom/fonts.css');

require('../module/nya-bootstrap-select-modified/dist/css/nya-bs-select.min.css');

require('ng-toast/dist/ngToast.min.css');
require('ng-toast/dist/ngToast-animations.min.css');

// NPM dependencies
require('browsernizr');
require('angular-sanitize');
require('angular-loading-bar');
require('@uirouter/angularjs');
require('angular-chart.js');
require('ngstorage');
require('angular-truncate-2');
require('ng-meta');
require('angular-sticky-plugin');
require('angular-bindonce');
require('ng-slide-down');
require('ng-toast');
require('angular-cookies');
require('angular-moment');
require('moment');
require('../module/ion-range-slider-angularjs-1.1.3');
require('angular-fancybox-plus/js/angular-fancybox-plus');
require('fancybox-plus/dist/jquery.fancybox-plus');
require('fancybox-plus/css/jquery.fancybox-plus.css');

// kathondvla Modules
require('@kathondvla/curriculum-manager');
require('@kathondvla/sri-client/ng-sri-client');

// Modules
require('../module/smart-icon/smartIcon.js');
require('../module/header/header');
require('../module/footer/footer');
require('../module/field-picker/fieldPicker');
require('../module/doughnut/doughnut');
require('../module/theme-picker/themePicker');
require('../module/bibWidget/bibWidget');
require('../module/bibContent-manager/bibContent-manager');
require('../module/bibMultimediaSection/bibiMultimediaSection');
require('../module/vsko-odet-manager');
require('../module/nya-bootstrap-select-modified');
require('../module/visionText');
require('../module/termHelper/termHelper');
require('../module/nodeHelper/nodeHelper');
require('../module/leerlijn/leerlijn');
require('../module/selection-chart/selectionChart');
require('../module/odetGoalConcordances/odetGoalConcordances');
require('../module/practicalExample');
require('../module/term/term');
require('../module/searchResult/searchResult');
require('../module/ageRange/ageRange');
require('../module/age-range-manager/ageRangeManager');

const kovSentry = require('./kovSentry');

/* global angular*/
var app = angular.module(
  'Zill',
  [
    'ng',
    'angular-loading-bar',
    'chart.js',
    'ui.router',
    'nya.bootstrap.select',
    'truncate',
    'ng-slide-down',
    'ngMeta',
    'ngToast',
    'hl.sticky',
    require('angular-ui-bootstrap'),
    'curriculumManager',
    'odetManager',
    'ageRangeManager',
    'smartIconModule',
    'header',
    'footer',
    'ngStorage',
    'pasvaz.bindonce',
    'fieldPicker',
    'doughnut',
    'themePicker',
    'bibWidget',
    'bibContentManager',
    'bibMultimediaSection',
    'visionText',
    'practicalExample',
    'termHelper',
    'nodeHelper',
    'leerlijn',
    'selectionChart',
    'ng-sri-client',
    'ion.rangeslider',
    'odetGoalConcordances',
    'term',
    'searchResult',
    'fancyboxplus',
    'ageRange',
    'ngCookies',
    'angularMoment'
  ]
);

app.constant('kovSentry', kovSentry);

// Default controllers
app.controller('HeadController', require('../app/headController.js'));
app.controller('HomeController', require('../screen/home/homeController.js'));

// Leerinhoud Controllers
app.controller('LeerinhoudOverviewController', require('../screen/leerinhoud/overview/leerinhoudOverviewController'));
app.controller('LeerinhoudFieldController', require('../screen/leerinhoud/field/leerinhoudFieldController'));
app.controller('LeerinhoudFieldMoreController', require('../screen/leerinhoud/field/leerinhoudFieldMoreController'));
app.controller('LeerinhoudThemeController', require('../screen/leerinhoud/theme/leerinhoudThemeController'));
app.controller('LeerinhoudThemeMoreController', require('../screen/leerinhoud/theme/leerinhoudThemeMoreController'));
app.controller('LeerinhoudGoalController', require('../screen/leerinhoud/goal/leerinhoudGoalController'));

// Bib Controllers
app.controller('BibSearchController', require('../screen/bib/search/bibSearchController'));
app.controller('BibSearchClassController', require('../screen/bib/search/classExamples/bibSearchClassController'));
app.controller('BibDisplayController', require('../screen/bib/display/bibDisplayController'));
app.controller('BibSearchTermController', require('../screen/bib/search/term/bibSearchTermController'));
app.controller('BibSearchTermDisplayController', require('../screen/bib/search/term/display/bibSearchTermDisplayController'));
app.controller('BibSearchConcordantiesController', require('../screen/bib/search/concordanties/bibSearchConcordantiesController'));
app.controller('BibIllustrationsController', require('../screen/bib/search/illustrations/bibIllustrationsController'));

// Concept Controllers
app.controller('ConceptController', require('../screen/concept/conceptController'));
app.controller('ConceptKrachtlijnenController', require('../screen/concept/krachtlijnen/conceptKrachtlijnenController'));
app.controller('ConceptKrachtlijnenHomeController', require('../screen/concept/krachtlijnen/home/conceptKrachtlijnenHomeController'));
app.controller('ConceptKrachtlijnenViewController', require('../screen/concept/krachtlijnen/view/conceptKrachtlijnenViewController'));
app.controller('ConceptLeeruitkomstController', require('../screen/concept/leeruitkomst/conceptLeeruitkomstController'));
app.controller('ConceptOrdeningskaderController', require('../screen/concept/ordeningskader/conceptOrdeningskaderController'));

// Support Controllers
app.controller('SupportController', require('../screen/support/supportController'));
app.controller('SupportHomeController', require('../screen/support/supportHomeController'));
app.controller('SupportOverzichtController', require('../screen/support/supportOverzichtController'));
app.controller('SupportViewController', require('../screen/support/supportViewController'));

// Search Controllers
app.controller('SearchController', require('../screen/search/searchController'));

module.exports = app;



// WEBPACK FOOTER //
// ./web/js/app/app.js